<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-19 17:08:44
 * @LastEditors: 诺
 * @LastEditTime: 2022-12-05 18:27:33
-->
<template>
  <div class="model" :style="{ borderColor: bColor }">
    <div class="modelTitle" :style="{ backgroundColor: bColor, color: textColor }">
      {{ title }}
    </div>
    <div class="modelBg">
      <slot name="progress"></slot>
      <div class="prizeTip" :style="{color:bColor}">虚拟礼品和实物礼品只能选择一个礼品领取</div>
      <div :class="['list', `list${index}`, key]" v-for="(arr, key, index) in items" :key="key">
        <div class="item-wrapper" v-for="(item, index) in arr" :key="index">
          <div class="state available" v-if="item.residue != 0 && assistanceNumber >= item.requireLevel && !item.isReceive && isReceive" @click="clickReceive(item)" :style="bgStyle">领取</div>
          <div
            :class="['item', { gray: item.residue == 0 }]"
            @click="clickReceive(item)"
            :style="
              item.residue != 0 && assistanceNumber >= item.requireLevel && !item.isReceive && isReceive
                ? {
                    filter: `drop-shadow(0px 2px 8px ${$util.rgbToRgba(btnBgColor, 0.5)})`,
                  }
                : null
            "
          >
            <div
              class="content"
              :style="{
                borderColor: item.residue == 0 ? '#A3AFBF' : assistanceNumber >= item.requireLevel && !item.isReceive && isReceive ? btnBgColor : bColor,
              }"
            >
              <!-- :style="{
                backgroundImage: `url(${item.img})${item.residue == 0 ? ',linear-gradient(#A3AFBF, #A3AFBF)' : ''}`,
              }" -->
              <div :class="['itemImg', { residue: item.residue }]">
                <img :src="item.img" />
              </div>
              <div
                class="text"
                :style="{
                  color: item.residue == 0 ? '#A3AFBF' : assistanceNumber >= item.requireLevel && !item.isReceive && isReceive ? btnBgColor : bColor,
                }"
              >
                <span>{{ item.requireLevel }}</span>
                {{ helpText }}
              </div>
            </div>
            <div
              class="name"
              :style="{
                backgroundColor: item.residue == 0 ? '#A3AFBF' : assistanceNumber >= item.requireLevel && !item.isReceive && isReceive ? btnBgColor : bColor,
                color: textColor,
              }"
            >
              <div :class="item.name .length>9?'name_animate':''" >
                {{ item.name }}
              </div>
            </div>

            <div class="state empty act-text-stroke" v-if="item.residue == 0">抢空</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data", "bColor", "title", "textColor", "helpText", "assistanceNumber", "btnBgColor", "isReceive", "myPrizeList"],
  data() {
    return { list: [] };
  },
  created() {},
  methods: {
    clickReceive(item) {
      console.log(item);
      // if (!this.isReceive || this.assistanceNumber < item.requireLevel) {
      //   return;
      // }
      // if (item.residue == 0) {
      //   return this.$showToast("奖品已被抢完!");
      // }
      if(this.myPrizeList.length>0){
        if(this.myPrizeList[0].actCode!=this.$actCode){
            this.$modal.tip.alert({
              type:'goAct',
              actCode:this.myPrizeList[0].actCode
            })
            return 
          }
      }
      if (item.residue != 0 && this.assistanceNumber >= item.requireLevel && !item.isReceive && this.isReceive) {
        this.$modal.tip.alert({
          type:'receive',
        }).then(res=>{
          if(res=='receive'){
            this.$modal.form
            .alert({
              type: "code",
              code: item.code,
              prizeName: item.name,
              receiveKey: item.code,
              prizeType: item.type,
            })
            .then((res) => {
              if (res == "success") {
                this.$emit('upPrize')
              }
            });
          }
        })
      }

    },
  },
  computed: {
    items() {
      if (this.data.length % 3 == 1) {
        return {
          first: [this.data[0]],
          three: this.data.slice(1),
        };
      } else if (this.data.length % 3 == 2) {
        // this.data[0].requireLevel = 0;
        return {
          two: [this.data[0], this.data[1]],
          three: this.data.slice(2),
        };
      } else {
        return {
          three: this.data,
        };
      }
    },
    bgStyle() {
      return {
        background: this.btnBgColor,
        boxShadow: `0px 2px 3px ${this.$util.rgbToRgba(this.btnBgColor, 0.2)}`,
      };
    },
    imgStyle(item) {
      console.log(item);
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.model {
  width: 351px;
  margin: 50px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 5px solid;
  box-sizing: border-box;

  .modelTitle {
    position: absolute;
    margin-top: -20px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    border-radius: 6px;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    z-index: 1;
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;
    .prizeTip{
      font-size: 14px;
      line-height: 14px;
      text-align: center;
      padding-top:10px;
    }

    .list {
      margin: 0 6px;
      display: flex;
      // align-items: center;
      flex-wrap: wrap;

      &.list0 {
        padding-top: 16px;
      }

      &:last-child {
        margin-bottom: 10px;
      }

      &.first {
        .item {
          .content {
            width: 317px;
            .itemImg {
              width: 315px;
              height: 130px;
              img {
                width: 305px;
                height: 120px;
              }
            }
          }

          .name {
            width: 317px;
          }
        }
      }

      &.two {
        .item {
          .content {
            width: 154px;
            .itemImg {
              width: 152px;
              height: 100px;
              img {
                width: 142px;
                height: 90px;
              }
            }
          }

          .name {
            width: 154px;
          }
        }
      }
      .item-wrapper {
        position: relative;
        margin: 0 5px 8px;
        .available {
          position: absolute;
          top: -8px;
          right: -8px;
          width: 40px;
          height: 40px;
          border: 1px solid #ffffff;
          box-sizing: border-box;
          border-radius: 50px;
          color: #fff;
          line-height: 40px;
          text-align: center;
          z-index: 4;
          font-size: 12px;
        }
      }
      .item {
        position: relative;
        border-radius: 4px;
        // overflow: hidden;

        &.gray {
          .content {
            .itemImg {
              img {
                filter: grayscale(60%);
                opacity: 0.5;
              }
            }
          }
        }

        .content {
          border-radius: 4px 4px 0 0;
          background-color: #f0f0f0;
          border-style: solid;
          border-width: 1px;
          width: 99px;
          .itemImg {
            width: 97px;
            height: 93px;
            padding: 4px 0;
            text-align: center;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            overflow: hidden;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% auto;
            background-blend-mode: luminosity;
            &.residue {
              // background: rgba(255, 255, 255, 0.6);
            }
            img {
              border-radius: 4px 4px 0 0;
              width: 87px;
              height: 83px;
              object-fit: contain;
            }
          }
          .text {
            margin-bottom: 4px;
            text-align: center;
            font-size: 9px;
            line-height: 16px;
            span {
              font-size: 16px;
              line-height: 18px;
              font-weight: bold;
            }
          }
        }

        .name {
          border-radius: 0 0 4px 4px;
          width: 99px;
          font-weight: normal;
          font-size: 11px;
          line-height: 12px;
          color: white;
          text-align: center;
          padding: 6px 2px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding:0 2px;
        }

        .empty {
          position: absolute;
          top: 26px;
          left: 50%;
          transform: translateX(-50%);
          width: 48px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          color: #fff;
          background: rgba(97, 112, 134, 0.6);
          border-radius: 50px;
          font-size: 14px;
        }
      }
      .gray {
        // background-image: url(https://assets.rurushishi.com/activies/activityCenter/turntableLottery/icon2.png), linear-gradient(#A3AFBF, #A3AFBF);
        // background-blend-mode: luminosity;
        // background-position: top center;
        // background-repeat: no-repeat;
        // background-size: 100% auto;
      }
    }
  }
}

.name_animate{
  animation: marquee_animate 10s infinite linear;
}
    
@keyframes marquee_animate {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
